import { render, staticRenderFns } from "./BasicSettings.vue?vue&type=template&id=49eeddf3&scoped=true"
import script from "./BasicSettings.vue?vue&type=script&lang=js"
export * from "./BasicSettings.vue?vue&type=script&lang=js"
import style0 from "./BasicSettings.vue?vue&type=style&index=0&id=49eeddf3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eeddf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49eeddf3')) {
      api.createRecord('49eeddf3', component.options)
    } else {
      api.reload('49eeddf3', component.options)
    }
    module.hot.accept("./BasicSettings.vue?vue&type=template&id=49eeddf3&scoped=true", function () {
      api.rerender('49eeddf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/operationsManagement/Component/BasicSettings.vue"
export default component.exports